import type { WorkflowGraph, WorkflowPreflightResult, WorkflowRuntimeStatus } from '../../api/workflowRuns'

import { lintWorkflowGraph, workflowGraphLintHasErrors } from './workflowGraphLint'

/** 模拟运行弹窗用：仅前端图 lint，不请求后端 preflight（避免旧后端 405） */
export function buildLocalWorkflowPreflight(
  graph: WorkflowGraph,
  runtime: WorkflowRuntimeStatus | null,
): WorkflowPreflightResult {
  const lintIssues = lintWorkflowGraph(graph.nodes, graph.edges, graph.inputSchema as Record<string, unknown> | undefined)
  return {
    runnable: !workflowGraphLintHasErrors(lintIssues),
    issues: lintIssues.map((issue) => ({
      level: issue.level,
      code: issue.code,
      message: issue.message,
      nodeId: issue.nodeId ?? '',
    })),
    runtime: runtime ?? {
      creationQueueEnabled: true,
      workflowWorkerAvailable: true,
      platforms: [],
    },
  }
}
